// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useCallback, useEffect, useRef, useState } from "../00-boot.jsx";
import { lanacFlagsFirstBootWait, lanacLeanSocialOn } from "../07-trust-moderation.jsx";
import { lanacSupabaseClient } from "../08-supabase-client.jsx";
// ── Tranche 4b · useSocial : abonnements, favoris sociaux ───────────────────
//  ⚠️⚠️ CLÉ SUFFIXÉE PAR L'UID DEPUIS LE 02/08/2026 (audit indépendant). Elle était
//  `lanac:follows` TOUT COURT, alors que les likes — deux effets plus bas — portaient déjà
//  `lanac:likes:<uid>` : une asymétrie, pas un choix. Conséquence sur un appareil PARTAGÉ :
//  après une déconnexion (le SPA reste monté), le graphe social de A servait d'état initial
//  à B, était affiché comme le sien, et RÉÉCRIT sous son identité au premier rendu — donc
//  une fuite qui persistait en local. Le loquet B5 élargissait la fenêtre d'affichage.
const FOLLOWS_KEY=(uid)=>`lanac:follows:${uid||"anon"}`;
function useSocial(me){
  const [followList,setFollowList]=useState(null); // {type:'followers'|'following'} — liste abonnés/abonnements de l'utilisateur lui-même
  const [follows,setFollows]=useState(()=>{try{return JSON.parse(localStorage.getItem(FOLLOWS_KEY(me?.id))||"{}");}catch{return{};}});
  useEffect(()=>{try{localStorage.setItem(FOLLOWS_KEY(me?.id),JSON.stringify(follows));}catch(e){}},[follows,me?.id]); // V3-T3a (uid en dep depuis le 02/08 : la clé en dépend). try/catch 28/08 : un quota plein ne doit pas faire remonter l'exception à l'ErrorBoundary racine (écran d'erreur persistant).
  // Hygiène : l'ancienne clé GLOBALE quitte les appareils qui la portent encore.
  useEffect(()=>{try{localStorage.removeItem("lanac:follows");}catch(e){}},[]);
  // Le graphe suit l'identité : au changement de compte, on repart de CE compte (le boot le remplira).
  useEffect(()=>{try{setFollows(JSON.parse(localStorage.getItem(FOLLOWS_KEY(me?.id))||"{}"));}catch{setFollows({});}},[me?.id]);
  // Fermeture A5 (13/07) : on ne charge plus la table follows ENTIÈRE. Les compteurs d'abonnés de
  // n'importe quel profil viennent des colonnes dénormalisées (followerCount/followingCount, triggers).
  // Ici on ne charge que MES arêtes (celles où je suis suiveur OU suivi) — bornées par MON activité —
  // suffisantes pour l'état du bouton « suivre » (isFollowingUser) et mes listes abonnés/abonnements.
  useEffect(()=>{
    const client=lanacSupabaseClient();
    if(!client||!me?.id) return;
    let b5cancelled=false;
    (async()=>{
    // EGRESS B5 : porte évaluée APRÈS la réponse `app_flags` sur une première visite
    //  (miroir absent) — sinon un appareil neuf chargeait le mur ENTRANT une fois pour rien
    //  (1 500 abonnés = 106,4 Ko au banc). Appareil instruit : résolution immédiate, zéro coût.
    await lanacFlagsFirstBootWait("lanac:leanSocialServer");
    if(b5cancelled) return;
    // EGRESS P2c · contrat 2a : le sens ENTRANT (mes abonnés) n'est PAS borné par ma propre
    //  activité (50 000 abonnés = 50 000 lignes au boot) et ne sert qu'une modale rarement
    //  ouverte. À ON : le boot ne charge que le sens SORTANT (l'état du bouton « suivre ») ;
    //  les abonnés arrivent à l'OUVERTURE (loadMyFollowers). À OFF : requête d'origine, intacte.
    const q=lanacLeanSocialOn()
      ? client.from("follows").select("follower_id,seller_id").eq("follower_id",me.id)
      : client.from("follows").select("follower_id,seller_id").or(`follower_id.eq.${me.id},seller_id.eq.${me.id}`);
    q.then(({data,error})=>{
      if(b5cancelled) return;
      if(!error&&Array.isArray(data)){
        // Map {followerId:[sellerIds]} construite dans LES DEUX SENS : mes abonnements (follower=moi)
        // ET mes abonnés (seller=moi → follows[sonId] contient mon id) pour la liste « abonnés ».
        const map={};
        data.forEach(r=>{if(!map[r.follower_id])map[r.follower_id]=[];map[r.follower_id].push(r.seller_id);});
        setFollows(map);
      }
    });
    })(); // B5 : fin de l'enveloppe « attendre les drapeaux avant la porte »
    return ()=>{b5cancelled=true;};
  },[me?.id,me?.gen]);
  // EGRESS P2c · les arêtes ENTRANTES, chargées à l'OUVERTURE de la modale abonnés (une fois
  //  par session, plafond 500) et MERGÉES dans la map — le filtre existant d'AppModals et
  //  l'hydratation de profils P1c font le reste. Inerte à OFF (le boot a déjà tout).
  const followersLoadedRef=useRef(false);
  const loadMyFollowers=useCallback(async()=>{
    try{
      // 02/08 (audit) : MEME LOQUET que la porte du boot. Sans lui, une modale ouverte dans
      //  la fenetre de premiere visite lisait le drapeau a OFF et sortait sur le motif
      //  « inerte a OFF : le boot a deja tout » — alors que le boot n'avait justement rien
      //  charge et chargerait ensuite le sens SORTANT SEUL ⇒ liste d'abonnes VIDE.
      await lanacFlagsFirstBootWait("lanac:leanSocialServer");
      const client=lanacSupabaseClient();
      if(!client||!me?.id||!lanacLeanSocialOn()||followersLoadedRef.current) return;
      followersLoadedRef.current=true;
      client.from("follows").select("follower_id").eq("seller_id",me.id).limit(500).then(({data,error})=>{
        if(error||!Array.isArray(data)){followersLoadedRef.current=false;return;}
        setFollows(prev=>{
          const map={...prev};
          data.forEach(r=>{const f=String(r.follower_id);const arr=map[f]?[...map[f]]:[];if(!arr.includes(me.id))arr.push(me.id);map[f]=arr;});
          return map;
        });
      },()=>{followersLoadedRef.current=false;});
    }catch(e){}
  },[me?.id]);
  // ── CHAINE « LIKE » DECOMMISSIONNEE LE 04/08/2026 — DECISION PRODUIT, FONDEE SUR LA MESURE ──
  //  La table `likes` comptait 0 LIGNE (0 utilisateur, somme des compteurs 0) : le signal n'a
  //  JAMAIS ete emis en production. Le doublon retenu est FAVORITES (coeur + compteur rendus
  //  sur chaque carte et la fiche) — une marketplace moderne n'a qu'UN signal d'affinite.
  //  Retire ici : l'etat `likes`, la requete de BOOT (−1 requete par session connectee), et
  //  les miroirs `lanac:likes:<uid>` (hygiene ci-dessous). Cote serveur : table + trigger
  //  supprimes par migration ; `listings.like_count` reste (compat listings_feed), commentee
  //  MORTE, a retirer a la prochaine revision de la RPC.
  useEffect(()=>{try{Object.keys(localStorage).filter(k=>k.indexOf("lanac:likes:")===0).forEach(k=>localStorage.removeItem(k));}catch(e){}},[]);
  return {followList,setFollowList,follows,setFollows,loadMyFollowers};
}
export { useSocial };
